const MAX_PHONE_NUMBER_LENGTH = 18;

export function handle(input) {
    input.addEventListener("focus", (event) => {
        if (!input.value) {
            input.value = "+";
        }
    });

    input.addEventListener("blur", (event) => {
        if (input.value === "+") {
            input.value = "";
        }
    });

    input.addEventListener("input", (event) => {
        input.value = "+" + input.value.replace(/\D/g, '').substring(0, MAX_PHONE_NUMBER_LENGTH);
    });
}

export function handleAll() {
    document.querySelectorAll("[data-phone-number-input]")
        .forEach(handle);
}
